import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestState } from '@shared/models/request-state';
import { StandbyListRequest } from './models/standby-list.request';
import { StandbyListResponse } from './models/standby-list.response';
import { ApiCacheService } from '@shared/services/api-cache.service';

@Injectable({
  providedIn: 'root',
})
export class StandbyListService {
  private readonly _url = `${environment.apiUrl}passengerlist`;

  constructor(private cacheService: ApiCacheService) {}

  getStandbyList(
    standbyListRequest: StandbyListRequest,
    isRefresh: boolean
  ): Observable<RequestState<StandbyListResponse>> {
    const { flightNumber, date, depStation } = standbyListRequest;
    const cacheId = this.getCacheId(standbyListRequest);
    const url = `${this._url}/${flightNumber}/${date}/${depStation}`;

    if (isRefresh) {
      return this.cacheService.forceRefreshGet<StandbyListResponse>(
        cacheId,
        url
      );
    } else {
      return this.cacheService.request<StandbyListResponse>(cacheId, url);
    }
  }

  private getCacheId(standbyListRequest: StandbyListRequest): string {
    const { flightNumber, date, depStation } = standbyListRequest;
    return `standby-list-${flightNumber}/${date}/${depStation}`;
  }
}
